/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_ContactPersonPermissionKinds {
    ManageOtherPublicUser = 10,
    ViewInvoice = 20,
    ViewPricelist = 30,
    ViewProjects = 40,
    ShowDekoSupportLink = 50,
    ShowPictureStoreLink = 60,
}
